export const HEADER_PORTAL_ID = "header-portal"
export const HEADER_TITLE_PORTAL_ID = "header-title-portal"
export const DEFAULT_TITLE_ATTRIBUTE = "data-default-title"
